;( function( $, undefined )
{

    $.fn.SiteCatalystComposePage = function( siteCat )
    {
        var that = siteCat;

        // House rules - View all
        $( '#rules-list' ).find( 'a' ).on( 'click', function()
        {
            that.track( 'House rules - View all', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:house rules:view all:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );
    };

} )( jQuery );